module.exports = "/assets/data/2ff5d4d2d2915ffc72f05b2cc9a3b675-SA38.data.json";